module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/cw_my_apps_ar-decace528140a157376ebdb9d816ceb6.svg";